import { render } from "./Credits.vue?vue&type=template&id=c88ad4da&scoped=true&ts=true"
import script from "./Credits.vue?vue&type=script&lang=ts"
export * from "./Credits.vue?vue&type=script&lang=ts"

import "./Credits.vue?vue&type=style&index=0&id=c88ad4da&scoped=true&lang=less"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c88ad4da"]])

export default __exports__